import moment from "moment";
import momentTimezone from "moment-timezone";
import _ from "lodash";
import { DEFAULT_TIMEZONE, DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from "@/config/common";
import { reftoken, authStatus } from "@/service"

/**
 * 获取所有时区
 * groupBy：offset/timezone
 * output like: [{offset: 'UTC-07:00', timezone: 'America/Mazatlan', label: '(UTC-07:00) America/Mazatlan'}]
 * */
export function timezoneList(groupBy = 'offset') {
    // Get all the available timezones
    const timezones = momentTimezone.tz.names();
    const res = []
    // Iterate over each timezone and get its UTC offset
    for (let i = 0; i < timezones.length; i++) {
        const timezone = timezones[i];
        const offset = momentTimezone.tz(timezone).format('Z');
        if (groupBy === 'offset') {
            const index = _.findIndex(res, ['offset', offset])
            if (index !== -1) {
                res[index].timezone.push(timezone)
            } else {
                res.push({
                    offset: offset,
                    timezone: [timezone],
                    label: `(${offset}) ${timezone}`
                })
            }
        } else {
            res.push({
                offset: offset,
                timezone: timezone,
                label: `(${offset}) ${timezone}`
            })
        }
    }
    return res
}

/**
 * 获取用户时区：用户有设置时区取用户设置的时区，没有设置取客户端的时区，都没有取系统默认时区
 *
 * */
export function getTimezone() {
    let userTimezone = localStorage.getItem('user_timezone')
    if (userTimezone) {
        userTimezone = JSON.parse(userTimezone)
        if (userTimezone.timezone) {
            return userTimezone.timezone
        }
    }
    let guessTimezone = moment.tz.guess()
    if (guessTimezone) {
        return guessTimezone
    }
    return DEFAULT_TIMEZONE
}
// 获取当前日期格式
export function getDateFormat() {
    let date_format = localStorage.getItem('user_date_format')
    if (date_format) {
        return date_format
    }
    return DEFAULT_DATE_FORMAT
}
// 获取当前时间格式
export function getTimeFormat() {
    let time_format = localStorage.getItem('user_time_format')
    if (time_format) {
        return time_format
    }
    return DEFAULT_TIME_FORMAT
}

// 按当前时区格式化时间
export function formatDatetime(datetimeString, format) {
    if (!datetimeString) {
        return ''
    }
    if (!format) {
        format = getDateFormat() + ' ' + getTimeFormat()
    }
    const timezone = getTimezone()
    return moment(datetimeString).tz(timezone).format(format)
}

// 转为utc时间格式
export function toUtcFormat(datetimeString) {
    if (!datetimeString) {
        return ''
    }
    return moment(datetimeString).utc().format()
}
export function getCurrentTime(format) {
    if (!format) {
        format = getDateFormat() + ' ' + getTimeFormat()
    }
    return moment().format(format)
}

export function getTimeAgo  (timestamp, timezone = null, format = null)  {
    if (!timezone) {
        timezone = getTimezone()
    }
    if (!format) {
        format = getDateFormat() + ' ' + getTimeFormat()
    }
    // 转换时区
    const time = moment(timestamp).tz(timezone);

    // 距离现在的时间
    const now = moment();
    const diffMinutes = now.diff(time, 'minutes');
    const diffHours = now.diff(time, 'hours');

    if (diffMinutes < 60) {
        return `${diffMinutes} 分钟前`;
    } else if (diffHours < 24) {
        return `${diffHours} 小时前`;
    } else {
        return time.format(format);
    }
}

/**
 * 获取指定月份的最后一天，返回格式：YYYY-MM-DD，如：2020-02-29
 * @param yearMonthStr: YYYY-MM
 * */
export function getLastDateOfMonth(yearMonthStr) {
    if (!yearMonthStr) {
        return ''
    }
    let [year, month] = yearMonthStr.split('-').map(Number);
    let date = new Date(year, month, 0);
    let monthStr = month < 10 ? '0' + month : month;
    let dayStr = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return `${year}-${monthStr}-${dayStr}`;
}

export function getOptionLabel(options, val) {
    if (!val) {
        return ''
    }
    const item = _.find(options, ['value',val])
    if (!item) {
        return ''
    }
    return _.get(item, 'label')
}

export function formatFileSize(sizeInBytes) {
    if (sizeInBytes < 1024) {
        return `${sizeInBytes} B`;
    } else if (sizeInBytes < 1024 ** 2) {
        return `${(sizeInBytes / 1024).toFixed(1)} KB`;
    } else {
        return `${(sizeInBytes / (1024 ** 2)).toFixed(1)} MB`;
    }
}

export function getStatusTxt(statusTxt, statusVal) {
    if (!statusTxt) {
        return ''
    }
    const txt = statusTxt[statusVal]
    if (!txt) {
        return ''
    }
    return txt
}

export function getLabel(options, value) {
    if (!value) {
        return ''
    }
    const item = options.find(item => item.value == value)
    if (!item) {
        return ''
    }
    return item.label
}

export function urlFormat(host, module, api) {
    return _.trimEnd(_.trim(host, '"'), "/") + "/" + _.trim(_.trim(module, '"'), "/") + "/" + _.trimStart(api, "/")
}
//保留小数
export function numberFormat(n, digits) {
    if(typeof n === 'string' || digits === -1) {
        return n
    }
    if(n === Infinity || isNaN(n)) {
        return 0
    }

    if(n === null || n === undefined) {
        return 0
    }

    return Number(Number(n).toFixed(digits || 2))
}
export function addressText(detail) {
    return _.get(detail, 'country_txt', '') +
      _.get(detail, 'province_txt', '') +
      _.get(detail, 'city_txt', '') +
      _.get(detail, 'address', '')
}

export function refreshTokenHandle(token) {
    reftoken({ refreshToken: token }).then(res => {
        console.log(res)
        if (res && res.payload) {
            localStorage.setItem("accessToken", res.payload.accessToken);
            localStorage.setItem("expiresAt", new Date(res.payload.expiresAt * 1000).toISOString());
            localStorage.setItem("refreshToken", res.payload.refreshToken);
            localStorage.setItem("refreshExpiresIn", new Date((res.payload.refreshExpiresIn ?? res.payload.expiresAt) * 1000).toISOString());
            authStatus(null)
        }
    }).catch((err)=>{
        console.log(err)
        localStorage.clear()
        window.location.href = "/"
    })
}

// verify email is valid
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
}
